import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22a544e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "set-pwd-tips" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yk_gantanhao_fill" }),
  /*#__PURE__*/_createTextVNode(" 首次使用齿轮币支付，需设置支付密码! ")
], -1))
const _hoisted_2 = { class: "step" }
const _hoisted_3 = { class: "step-left" }
const _hoisted_4 = { class: "step-title" }
const _hoisted_5 = { class: "title-icon" }
const _hoisted_6 = { class: "step-right" }
const _hoisted_7 = { class: "step-title" }
const _hoisted_8 = { class: "title-icon" }
const _hoisted_9 = { class: "set-pay-pwd" }
const _hoisted_10 = {
  key: 0,
  class: "pwd-box"
}
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = {
  key: 1,
  class: "count-down"
}
const _hoisted_14 = { class: "pwd-box" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yanjing_yincang" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yanjing_xianshi" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("i", {
              class: _normalizeClass(["icon iconfont icon-1", { active: _ctx.step == 1 }])
            }, null, 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["title-line", { active: _ctx.step == 2 }])
          }, null, 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["step-info", { active: _ctx.step == 1 }])
        }, "设置支付密码", 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", {
              class: _normalizeClass(["icon iconfont icon-2", { active: _ctx.step == 2 }])
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["step-info", { active: _ctx.step == 2 }])
        }, "支付", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, "通过" + _toDisplayString(_ctx.showMobile(_ctx.userinfo.mobile)) + "接收短信验证码", 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.setPayPassword.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setPayPassword.code) = $event)),
                placeholder: "请输入验证码"
              }, null, 8, ["modelValue"]),
              (_ctx.isShow)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "count-down",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.countdown && _ctx.countdown(...args)))
                  }, " 获取短信验证码 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.countShowText), 1))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_16, [
          (!_ctx.showPwd)
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: _ctx.setPayPassword.pay_password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.setPayPassword.pay_password) = $event)),
                type: "password",
                placeholder: _ctx.title
              }, null, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          (_ctx.showPwd)
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: _ctx.setPayPassword.pay_password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.setPayPassword.pay_password) = $event)),
                placeholder: "请输入6位数字"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (!_ctx.showPwd)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeShowPwd && _ctx.changeShowPwd(...args))),
                class: "now-password"
              }, _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.showPwd)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeShowPwd && _ctx.changeShowPwd(...args))),
                class: "now-password"
              }, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit,
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}